module.exports = __webpack_public_path__ + "static/media/261510.c5f4a508.png";